/**
 * Campaign-attribution params carried on the query string of an inbound link.
 *
 * Every field is optional — a link carries whichever subset its generator
 * emitted, and a consumer that needs a specific one checks for it.
 *
 * `utm_post_id`, `utm_username` and `utm_user_id` exist because the ECHO
 * Comment-to-DM agent's checkout links carry them; upstream PopshopRN read them
 * off an untyped `Record<string, string | undefined>` cast rather than declaring
 * them, which is why they were invisible to the compiler. They are declared here
 * so the whole set is ONE typed shape.
 */
export interface UtmParameters {
  utm_medium?: string;
  utm_source?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  utm_shop_identifier?: string;
  utm_listing_id?: string;
  utm_product_id?: string;
  utm_video_id?: string;
  utm_post_id?: string;
  utm_username?: string;
  utm_user_id?: string;
  /** An Auto Selling offer the buyer arrived to claim. */
  utm_offer_claim_id?: string;
}

/**
 * Every key of {@link UtmParameters}. The single source of truth for which
 * params are recognised — the query parser and the persisted round-trip both
 * read it, so adding a field to the interface is the only edit needed.
 */
export const kUtmParameterKeys = [
  'utm_medium',
  'utm_source',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_shop_identifier',
  'utm_listing_id',
  'utm_product_id',
  'utm_video_id',
  'utm_post_id',
  'utm_username',
  'utm_user_id',
  'utm_offer_claim_id',
] as const satisfies readonly (keyof UtmParameters)[];
